
export default function Applications() {
  return (
    <section id="applications" className="relative py-0" style={{
      backgroundImage: 'url(https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/740469727c0a2473327c621f80af2ccf.jpeg)',
      backgroundRepeat: 'repeat',
      backgroundSize: 'auto'
    }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-0 gap-8 pt-4">
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight max-w-xl">
            Hydrogen Applications
          </h2>
          <p className="text-lg text-gray-600 max-w-md leading-relaxed text-justify">
            Versatile solutions powering the transition to a sustainable energy future across multiple industries
          </p>
        </div>

        {/* SVG Infographic Section */}
        <div className="my-0 py-20">
          {/* Desktop Version */}
          <img 
            src="https://res.cloudinary.com/drhgl7kdc/image/upload/v1768574084/infographic_illustration_vector_cropped_r1ftrv.svg"
            alt="Hydrogen Technology Infographic"
            className="hidden lg:block w-full h-auto"
          />
          {/* Mobile Version */}
          <img 
            src="https://res.cloudinary.com/drhgl7kdc/image/upload/v1768574657/infographic_illustration_vector_mobile_hkrdey.svg"
            alt="Hydrogen Technology Infographic"
            className="block lg:hidden w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
}
